import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const FilterBarStyled = styled(Box)({
  marginBottom: '16px',
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#fff',
  },
});
